import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withVariants } from './util';
const IconSize32 = (_jsx("svg", Object.assign({ viewBox: "0 0 20 20" }, { children: _jsxs("g", Object.assign({ fill: "currentColor", fillRule: "nonzero", transform: "translate(1 1)" }, { children: [_jsx("path", { d: "M1 1v16h16V1H1zm0-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z" }, void 0), _jsx("path", { d: "M3.5 10a.5.5 0 0 1 0-1h11.1a.5.5 0 1 1 0 1H3.5z" }, void 0)] }), void 0) }), void 0));
export const variants = {
    default: IconSize32,
};
export default withVariants(variants);
